// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
// import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

// configure Swiper to use modules
// Swiper.use([Navigation, Pagination, Autoplay]);

// import the latest version
// import Swiper, {
//   Navigation,
//   Pagination,
//   Autoplay,
//   EffectCreative,
// } from "swiper";
//
// // configure Swiper to use modules
// Swiper.use([Navigation, Pagination, Autoplay, EffectCreative]);

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-simple", {
  // observer: true,
  // observeParents: true,
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    992: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
  },
});

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-container-nonstop-slide .swiper-container", {
  // observer: true,
  // observeParents: true,
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 41,
  initialSlide: 2,
  loop: true,
  speed: 7500,
  allowTouchMove: false,
  autoplay: {
    enabled: true,
    delay: 1,
  },
});

/*
 *
 * ----------------------------------------------- */
// new Swiper(".mySwiper3", {
//   grabCursor: true,
//   effect: "creative",
//   creativeEffect: {
//     prev: {
//       shadow: true,
//       translate: ["-20%", 0, -1],
//     },
//     next: {
//       translate: ["100%", 0, 0],
//     },
//   },
// });
